import { render, staticRenderFns } from "./user-transactions-tiles.vue?vue&type=template&id=0bb9747b"
import script from "./user-transactions-tiles.js?vue&type=script&lang=js&external"
export * from "./user-transactions-tiles.js?vue&type=script&lang=js&external"
import style0 from "./user-transactions-tiles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports